import * as yup from "yup";
import {
  testFloat,
  testFloatAndMoney,
  testPositiveFloat,
} from "../../../../utilities/form-validation";

export const schema = yup.object().shape({
  productId: yup.string().optional(),
  costPrice: yup
    .string()
    .test("valid-money", "Invalid Value", testFloat as any)
    .test("positive", "Quantity must be positive", testPositiveFloat as any)
    .required("Cost Price is required"),

  webPrice: yup
    .string()
    .test("valid-money", "Invalid Value", testFloat as any)
    .test("positive", "Quantity must be positive", testPositiveFloat as any)
    .optional(),

  tradePrice: yup
    .string()
    .test("valid-money", "Invalid Value", testFloat as any)
    .test("positive", "Quantity must be positive", testPositiveFloat as any)
    .optional(),

  quantity: yup
    .string()
    .test("valid-money", "Invalid Value", testFloat as any)
    .test("positive", "Quantity must be positive", testPositiveFloat as any)
    .required("Quantity is required"),
  retailPrice: yup
    .string()
    .test("valid-money", "Invalid Value", testFloatAndMoney as any)
    .test("positive", "Quantity must be positive", testPositiveFloat as any)
    .required("Retail Price is required"),
  barcode: yup.string().when("productId", {
    is: (productId: string) => !productId,
    then: yup.string().required("Barcode is required"),
    otherwise: yup.string().optional(),
  }),
  name: yup.string().optional(),
});
